import {
    BackButton,
    BoxTypeSelection, BoxTypeSelectionResult,
    useBoxes,
    View,
    ViewContent,
    ViewDescription,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {getBoxTypes} from "@variocube/app-common";
import {useLocalization} from "../i18n";

const IGNORE_TYPES = [ "PrivateBox" ];

interface SizeSelectionViewProps {
    onBack: () => void;
    onSelect: (result: BoxTypeSelectionResult) => void;
}

export function SizeSelectionView({onBack, onSelect}: SizeSelectionViewProps) {
    const {t} = useLocalization();
    const boxes = useBoxes();
    const types = getBoxTypes(boxes)
        .filter(type => !IGNORE_TYPES.includes(type));

    return (
        <View>
            <ViewHeader className={styles.viewHeader}>
                <ViewHeaderItem>
                    <BackButton onClick={onBack} label={t("Back")}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill>
                    <ViewTitle>{t("SelectSizeTitle")}</ViewTitle>
                    <ViewDescription>{t("SelectSizeDescription")}</ViewDescription>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={styles.viewContent}>
                <BoxTypeSelection
                    strings={t}
                    onSelect={onSelect}
                    types={types}
                />
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    viewHeader: {
        boxShadow: "0 0.1em 0.3em -0.1em rgba(0, 0, 0, 0.5)",
        zIndex: 1,
    },
    viewContent: {
        display: "flex"
    }
});
